var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M20.5449 20.5459L8.52411 8.52508",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M4.98828 4.9895L1.45275 1.45397",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1_2",
    d: "M20.5449 1.45394L1.54492 20.454",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebtn);
export default __webpack_public_path__ + "static/media/closebtn.f373a2e30127247940041a1f5089df03.svg";
export { ForwardRef as ReactComponent };